<template>
  <div>
    <v-card
      color="#1F7087"
      dark
    >
      <div class="d-flex flex-no-wrap justify-space-between">
        <div>
          <v-card-title
            class="text-h5"
            v-text="'Actividades'"
          ></v-card-title>

          <v-card-subtitle v-text="'Exportar a excel todos las actividades definidas (solo las definiciones) tanto corporativos como personalizados por hotel'"></v-card-subtitle>

          <v-card-actions>
            <v-btn
              class="ml-2"
              outlined
              rounded
              small
              @click="handleExport"
              style="margin-bottom: 10px;"
            >
              exportar excel
            </v-btn>
          </v-card-actions>
        </div>
      </div>
    </v-card>
    <!--div v-for="item of contentTypes">
      {{item}}
      <br/>
      <br/>
    </div-->
  </div>
</template>
<script>
import * as XLSX from "xlsx"
import api from '@/services/api'
import utils from '@/services/utils'
export default {
	props: {
	},
	data: () => ({
    loading: false,
    contentTypes: [],
		values: null,
    languages: null,
	}),
	computed: {
    /*
    languages () {
      return ['en', 'es', 'it', 'de ', 'pt', 'fr']
    },*/
		debug () {
      if (process.env.VUE_APP_ENV === 'development') return true
			return this.$route.query.debug && this.$route.query.debug.length > 0
		},
    weekDay () {
      return [
        'Lunes',
        'Martes',
        'Mi�rcoles',
        'Jueves',
        'Viernes',
        'S�bado',
        'Domingo',
      ]
    },
		customStyle () {
			let result = ''
			for (const row of this.rows){
				const color = row.color ? row.color : '#FFFFFF'
				result += `
										<Style ss:ID="row${row.id}">
              				<Alignment ss:Vertical="Top" />
											<Interior ss:Color="${color}" ss:Pattern="Solid"></Interior>
              				<Borders>
												<Border ss:Color="${color}" ss:Weight="2" ss:LineStyle="Continuous" ss:Position="Right"/>
												<Border ss:Color="${color}" ss:Weight="2" ss:LineStyle="Continuous" ss:Position="Left"/>
												<Border ss:Color="${color}" ss:Weight="2" ss:LineStyle="Continuous" ss:Position="Top"/>
												<Border ss:Color="${color}" ss:Weight="2" ss:LineStyle="Continuous" ss:Position="Bottom"/>
              				</Borders>
											<Font ss:Color="${utils.getOppositeColor(color)}"></Font>
              			</Style>
									`
			}
			return result
		},
	},
  methods: {
    getTranslation(v, locale, autoCompleteIfNull) {
      if (autoCompleteIfNull) return utils.getTranslation(v, locale)
      return v ? v[locale] : null
    },
    prepareDate (v) {
      if (!v) return
      const date = new Date(v)
      return `${utils.pad(date.getDate())}/${utils.pad((date.getMonth() + 1))}/${date.getFullYear()}`
    },
    convertTime (v) {
      if (!v) return '00:00'

      const h = v / 60 | 0
      const m = v - (h * 60)
      return `${h} : ${utils.pad(m)}`
    },
		prepareData (v, languages) {
			const result = []
      for (const event of v) {
        const aux = {}

        aux['Plan'] = event.PlanID
        aux['Typology'] = event.Typology//(event.SubcategoryExcelID || event.SubcategoryID) === 'special' ? 'special' : 'standard'
        aux['Category'] = event.CategoryID
        aux['Subcategory'] = event.SubcategoryID
        //title
        for (const l of languages) {
          aux[`Name (${l})`] = event.Title ? this.getTranslation(JSON.parse(event.Title), l, true) : ''
        }
        //description
        for (const l of languages) {
          aux[`Description (${l})`] = event.Description ? this.getTranslation(JSON.parse(event.Description), l, true) : ''
        }
        aux['Image'] = event.Image
        /*
        //aux['D�a'] = event.Date	
        aux['D�a'] = this.prepareDate(event.Date)
        aux['Hora Inicio'] = event.Time ? this.convertTime(event.Time).split(' ').join('') : null
        aux['Hora Fin'] = event.TimeEnd ? this.convertTime(event.TimeEnd).split(' ').join('') : null
        for (const l of this.languages) {
          aux[`Actividad (${l})`] = this.getTranslation(JSON.parse(event.Title), l, true)
        }
        
        aux[`Locacion`] = this.getTranslation(JSON.parse(event.Place), 'es')

        aux['ID'] = event.ID
        aux['Imagen'] = event.Image
        
        for (const l of this.languages) {
          aux[`Descripci�n (${l})`] = event.Description ? this.getTranslation(JSON.parse(event.Description), l, true) : ''
        }
        aux[`Reservable`] = event.Reservable ? 'reservable' : null
        aux[`PVP alojado`] = event.Reservable ? event.PVPHosted : null
        aux[`Cupos`] = event.Reservable ? event.PAX : null
        //aux[`PVP no alojado`] = event.Reservable ? event.PVPNoHosted : null
        */
        /*
        for (const l of this.languages) {
          aux[`Ubicaci�n (${l})`] = this.getTranslation(JSON.parse(event.Place), l)
        }
        */
        result.push(aux)
      }

			return result
		},
		getValue (weekID, mealID, rowID, optionID, day) {
			const aux = this.values.filter(x => 
                  x.Week === weekID &&
                  x.Row === rowID &&
                  x.Meal === mealID &&
                  x.Day === day.toString() &&
                  (!optionID || x.Option === optionID)
                ).map(item => item.Value).shift()
      return aux ? aux : ''
		},
		async handleExport () {
      try {

        this.loading = true
        const contentTypes = await new Promise((resolve, reject) => api.getAllWithoutLimit ('dviewcontent', 'v1/private/activity-barcelo-01/excel/content-types/')
            .then(response => {
              response.unshift({ ID: null, WorkspaceName: 'Corporativo' })
              resolve(response.map(item => {
                return {
                  ID: item.ID,
                  Name: item.WorkspaceName,
                  Languages: item.Languages ? JSON.parse(item.Languages) :  ["es", "en", "de", "it", "pt", "fr"]
                }
              }))
            })
          .catch (err => {
            reject(err)
          }))
        if (contentTypes) {
          for(let i = 0; i < contentTypes.length; i++) {
            contentTypes[i].Events = []
            contentTypes[i].Events.push(...await new Promise((resolve, reject) => api.getAllWithoutLimit ('dviewcontent', `v1/private/activity-barcelo-01/excel/content-type-events/${contentTypes[i].ID ? contentTypes[i].ID : ''}`)
                .then(response => {
                  resolve(response)
                })
              .catch (err => {
                reject(err)
              })))
          }
        }
        this.contentTypes = contentTypes
        this.handleCreateExcel(contentTypes)
      /*
      this.languages = await new Promise((resolve, reject) => api.getItem ('dviewcontent', 'v1/public/workspaces/', this.workspaceID)
          .then(response => {   
            resolve(response.Languages ? JSON.parse(response.Languages) : [])
          })
        .catch (err => {
          reject(err)
        }))
      const url = `v1/public/activity-barcelo/${this.contentTypeDataID}/excel`
      api.getAll ('dviewcontent', url, 0, 1000, '')
        .then(response => {
          if (this.contentTypeData.Show) {
            this.handleCreateExcel(`Calendario - Show.xls`, `Show`, response)
          } else {
            for (const category of this.contentTypeData.Categories) {
              this.handleCreateExcel(`Calendario - ${this.getTranslation(category.Name, 'es')}.xls`, `${this.getTranslation(category.Name, 'es')}`, response.filter(x => x.CategoryID === category.ID))
            }
          }
          this.loading = false
        })
        .catch (error => {
          console.log(error)
          this.loading = false
        })
      */
      } catch (error) {
        console.log(error)
      }
    },

    /*
    handleCreateExcel (fileName, pageName, data) {
      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      const wb = XLSX.utils.book_new()

      const ws = XLSX.utils.json_to_sheet(this.prepareData(data))
      XLSX.utils.book_append_sheet(wb, ws, pageName)

			const excelBuffer = XLSX.write(wb, { bookType: "xls", type: "array" });

			const fileData = new Blob([excelBuffer], { type: fileType });
			var link = document.createElement("A")
			link.href = URL.createObjectURL(fileData)
			link.download = fileName
			link.target = '_blank'
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		},
    */
    handleCreateExcel (v) {
      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      const wb = XLSX.utils.book_new()

      for (const page of v) {
        const ws = XLSX.utils.json_to_sheet(this.prepareData(page.Events, page.Languages))
        XLSX.utils.book_append_sheet(wb, ws, page.Name.replace('BARCELO_', '').substring(0,30))
      }

			const excelBuffer = XLSX.write(wb, { bookType: "xls", type: "array" });

			const fileData = new Blob([excelBuffer], { type: fileType });
			var link = document.createElement("A")
			link.href = URL.createObjectURL(fileData)
			link.download = 'ActivityBarcelo.xls'
			link.target = '_blank'
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		},
  },
}
</script>



